import { render } from "./UserNotFound.vue?vue&type=template&id=4c43a908&scoped=true"
import script from "./UserNotFound.vue?vue&type=script&lang=js"
export * from "./UserNotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c43a908"]])

export default __exports__